import { render, staticRenderFns } from "./tracks.vue?vue&type=template&id=03735648&scoped=true&"
import script from "./tracks.vue?vue&type=script&lang=ts&"
export * from "./tracks.vue?vue&type=script&lang=ts&"
import style0 from "./tracks.vue?vue&type=style&index=0&id=03735648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03735648",
  null
  
)

export default component.exports